import React from 'react'

export default function SortArrow() {
  return (<>
    <span>{"\u2191"}</span><span>{"\u2193"}</span>
    </>
  )
}
